const Negotiations = [
  {
    path: '/negotiations',
    name: 'Negotiations',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Negociações',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/negotiations/Negotiations.vue`)
  },
  {
    path: '/rn',
    name: 'RequestNegotiation',
    meta: { 
      // auth: false,
      // needs_company: true,
      tab_name: 'Solicitar negociação',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/negotiations/RequestNegotiation.vue`)
  },
  {
    path: '/negotiation/:negotiation_id',
    name: 'Negotiation',
    meta: { 
      // needs_company: true,
      tab_name: 'Acompanhar negociação',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/negotiations/RequestNegotiation.vue`)
  }, 
  {
    path: '/confirm_negotiation_sended',
    name: 'ConfirmSended',
    meta: { 
      // needs_company: true,
      tab_name: 'Confirmação de envio',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/negotiations/ConfirmNegotiationSended.vue`)
  }, 
  {
    path: '/new_negotiation',
    name: 'NewNegotiation',
    meta: { 
      // needs_company: true,
      tab_name: 'Nova negociação',
      icon: '📃'
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/events_agenda/NewEvent.vue`)
  },
]

export default Negotiations
